import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ["dropDownMenu", "switch"];

  toggleMenu() {
    this.dropDownMenuTarget.classList.toggle('is-active');
  }

  toggleSwitch() {
    let switchHiddenField =  this.element.querySelector('[data-behaviour="switch-value"]');
    if (switchHiddenField !== undefined) {
      switchHiddenField.value = this.switchTarget.checked
    }
  }

}

